<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-dialog
        v-model="dialogCreate"
        persistent
        max-width="700px"
        transition="dialog-transition"
        v-if="dialogCreate"
      >
        <v-card class="no__padding">
          <v-card-title>
            <h2>Vytvořit nový spořící produkt</h2>
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <v-form ref="createForm" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex xs12 sm9>
                  <v-text-field label="Spořící program" v-model="newItem.sporici_program" class="mx-2" :rules="rulesRequired"></v-text-field>
                </v-flex>
                <v-flex xs12 sm3>
                  <meny v-model="newItem.mena_id"></meny>
                </v-flex>
              </v-layout>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-3 elevation-0" dark @click="create" :loading="sending">Vytvořit</v-btn>
            <v-btn color="grey lighten-3 elevation-0" @click="dialogCreate=false" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap class="mb-3">
              <v-flex xs12 sm6>
                <h3>Spořící produkty</h3>
              </v-flex>
              <v-flex xs12 sm6 class="text-xs-left text-sm-right">

              </v-flex>
            </v-layout>
            <v-layout row wrap align-center class="mt-3">
              <v-flex xs12 sm4 md4 lg3>
                <v-text-field
                  label="Hledat dle názvu spořícího produktu"
                  class="mx-2"
                  v-model="search"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md4 lg5>
                <v-btn-toggle mandatory v-model="filtr_stav" class="btn-toggle__mobile mb-3 mx-3">
                  <v-btn value="vse">Vše</v-btn>
                  <v-btn value="aktivni">Aktivní</v-btn>
                  <v-btn value="neaktivni">Neaktivní</v-btn>
                </v-btn-toggle>
              </v-flex>
              <v-flex xs12 sm8 md8 lg4 class="text-xs-center text-sm-right">
                <v-btn color="blue darken-3" class="ma-0 mb-3" :class="{'v-btn--block mt-3 px-2': $vuetify.breakpoint.xs}" outline @click="createClick">
                  <v-icon class="mr-2">add</v-icon>
                  Vytvořit spořící produkt
                </v-btn>
              </v-flex>
            </v-layout>
            <div class="table-border__radius">
              <v-data-table
                :headers="headers"
                :items="items"
                :loading="loadingTable"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
              >
                <template slot="items" slot-scope="props">
                  <td style="min-width: 0; max-width: 24px;"><v-checkbox disabled v-model="props.item.aktivni" hide-details style="max-width: 40px;"></v-checkbox></td>
                  <td><router-link :to="{ path: '/sporici-produkty/'+props.item.id }">{{ props.item.sporici_program }}</router-link><span v-if="props.item.pouze_admin"> (pouze Admin)</span></td>
                  <td>{{ props.item.mena.nazev }}</td>
                  <td class="text-xs-right">{{ props.item.min_mesicni_splatka | formatMoney }} {{ props.item.mena.zkratka }}</td>
                  <td class="text-xs-right">{{ props.item.vstupni_poplatek | formatDouble }} %</td>
                  <td class="text-xs-right">{{ props.item.vstupni_poplatek | formatDouble }} %</td>
                  <td class="text-xs-right">{{ props.item.min_cilova_castka | formatMoney }} {{ props.item.mena.zkratka }}</td>
                  <td>
                    <div v-for="(c, i) in props.item.cilove_produkty" :key="'cp-'+props.item.id+'-p-'+i.toString()">
                      <router-link :to="{ path: '/produkty/'+c.id }" target="_blank">
                        {{c.nazev}}
                      </router-link>
                    </div>
                  <td class="text-xs-right">
                    <v-layout row>
                      <v-flex>
                        <router-link :to="{ path: '/sporici-produkty/'+props.item.id }" target="_blank">
                          <v-btn color="primary" class="elevation-0">
                          <v-icon small class="mr-2">remove_red_eye</v-icon> Detail</v-btn>
                        </router-link>
                      </v-flex>
                      <v-flex>
                        <router-link :to="{ path: '/sporici-produkty/'+props.item.id+'/upravit' }" target="_blank">
                          <v-btn color="primary" class="elevation-0 mr-0" flat>
                            <v-icon small class="mr-2">edit</v-icon>
                            Upravit
                          </v-btn>
                        </router-link>
                      </v-flex>
                    </v-layout>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      updateItem: {},
      headers: [
          { text: 'Aktivní', value: 'aktivni', width: '30px' },
          { text: 'Spořící program', value: 'sporici_program' },
          { text: 'Měna', value: 'mena' },
          { text: 'Min. měs. splátka', value: 'min_mesicni_splatka', align: "right" },
          { text: 'Vst. poplatek na začátku (%)', value: 'vstupni_poplatek', align: "right" },
          { text: 'Vst. poplatek na splátky (%)', value: 'vstupni_poplatek', align: "right" },
          { text: 'Min. cílová částka', value: 'min_cilova_castka', align: "right" },
          { text: 'Cílové produkt', value: 'cilove_produkty', sortable: false },
          { text: 'Zobrazit', value: null, sortable: false, align: "right" }
        ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
        sortBy: "id",
        totalItems: 0
      },
      items: [],
      valid: true,
      dialogCreate: false,
      sending: false,
      dialogInit: {
        sporici_program: null,
        mena_id: null
      },
      newItem: null,
      // Dialog create end
      // Rules start
      rulesRequired: [
        (v) => !!v || "Pole je vyžadováno"
      ],
      filtr_stav: "vse"
    }
  },
  watch: {
    search () {
      this.queryList();
    },
  	pagination: {
  		handler: function(newValue) {
  			this.load();
  		},
  		deep: true
  	},
    filtr_stav () {
      this.pagination.page = 1;
      this.load();
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("sporici-produkty/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        stav: this.filtr_stav
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    createClick () {
      this.newItem = window.th.copy(this.dialogInit);
      this.dialogCreate = true;
    },
    create () {
      if (this.$refs.createForm.validate()) {
        this.sending = true;
        window.API.post("sporici-produkty", this.newItem).then(function(body) {
          if (body.inserted) {
            this.$router.push({path:"/sporici-produkty/"+body.data.id+'/upravit'});
          }
          this.sending = false;
        }.bind(this)).catch(function(err) {
          console.log(err);
          this.sending = false;
        }.bind(this));
      }
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Produkty/SporiciProdukty.vue